// extracted by mini-css-extract-plugin
export var testimonial = "testimonials-module--testimonial--11594";
export var testimonialAttr = "testimonials-module--testimonialAttr--aee7a";
export var testimonialBtn = "testimonials-module--testimonialBtn--7b04b";
export var testimonialImage = "testimonials-module--testimonialImage--fc7de";
export var testimonialLocation = "testimonials-module--testimonialLocation--08f5e";
export var testimonialName = "testimonials-module--testimonialName--330cd";
export var testimonialQuote = "testimonials-module--testimonialQuote--e3a8f";
export var testimonialSmall = "testimonials-module--testimonialSmall--532d8";